import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { motion } from "framer-motion";
import { ReactNode } from "react";

interface ChartCardProps {
  title: string;
  description?: string;
  badge?: string;
  children: ReactNode;
  delay?: number;
}

export function ChartCard({ title, description, badge, children, delay = 0 }: ChartCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay }}
    >
      <Card className="border-border/50 hover:border-primary/30 transition-all hover:shadow-lg">
        <CardHeader className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 p-4 sm:p-6">
          <div className="space-y-0.5">
            <CardTitle className="text-base sm:text-lg">{title}</CardTitle>
            {description && <CardDescription className="text-xs sm:text-sm">{description}</CardDescription>}
          </div>
          {badge && (
            <Badge variant="secondary" className="text-[10px] sm:text-xs w-fit">
              {badge}
            </Badge>
          )}
        </CardHeader>
        <CardContent className="p-4 sm:p-6 pt-0">
          {children}
        </CardContent>
      </Card>
    </motion.div>
  );
}
